import "@assets/css/components/DashboardUsuarios/DataTables/style.css";

import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Dropdown,
  Row,
} from "react-bootstrap";

import { AgregarEmpleado } from "../../Modales/Empleado/AgregarEmpleado/AgregarEmpleado";
import { ModalSweetAlert } from "@components/general/Alertas/Alertas";
import React from "react";
import TableEmpleados from "@components/administrador/DashboardUsuarios/DataTables/Empleado/TableEmpleados";
import { addEmpleadoMasivo } from "@helpers/httpRequests/httpRequestsUsuarios/empleados/httpRequestsEmpleados";
import { useState } from "react";

export const DashboardEmpleados = ({ isTabActive }) => {
  const handleAgregarEmpleado = async () => {
    try {
      await ModalSweetAlert({
        title: "Agregar empleado",
        html: <AgregarEmpleado setEmpleadoAgregado={setEmpleadoAgregado} />,
        showCloseButton: true,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log("Error al agregar al empleado: ", error);
    }
  };

  const handleAgregarEmpleadosMasivo = () => {
    const fileInput = document.createElement("input");

    fileInput.type = "file";

    fileInput.addEventListener("change", async ({ target }) => {
      try {
        const selectedFile = target.files[0];

        const rows = await window.readXlsxFile(selectedFile);

        const [encabezados, ...empleados] = rows;

        let dataEmpleados = [];

        for (let i = 0; i < empleados.length; i++) {
          dataEmpleados.push({
            folioContrato: empleados[i][0],
            nombreUsuario: empleados[i][1],
            contrasenia: empleados[i][2],
            nombre: empleados[i][3],
            apellidos: empleados[i][4],
            correo: empleados[i][5],
            profesion: empleados[i][6],
            curp: empleados[i][7],
          });
        }

        await addEmpleadoMasivo(dataEmpleados);

        setEmpleadoAgregado(true);
      } catch (error) {
        console.log("Error al leer los datos del archivo: ", error);
      }
    });

    fileInput.click();
  };

  const [empleadoAgregado, setEmpleadoAgregado] = useState(false);

  return (
    isTabActive && (
      <Container fluid className="pt-3">
        <Row>
          <Col align="left">
            <Dropdown as={ButtonGroup}>
              <Button variant="primary" onClick={handleAgregarEmpleado}>
                Agregar empleado
              </Button>

              <Dropdown.Toggle split variant="primary" />

              <Dropdown.Menu>
                <Dropdown.Item href="#" onClick={handleAgregarEmpleadosMasivo}>
                  Agregar desde archivo
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <TableEmpleados
              empleadoAgregado={empleadoAgregado}
              setEmpleadoAgregado={setEmpleadoAgregado}
            />
          </Col>
        </Row>
      </Container>
    )
  );
};
